export default "__VITE_ASSET__aDBlrgbB__"